
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer-a-friend",
      function () {
        return require("private-next-pages/refer-a-friend.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer-a-friend"])
      });
    }
  